export default [
	{
		path: "/pros/messages",
		exact: true,
		policy: "providerAuth",
		component: "Inbox",
		mui: true,
	},
];
